
export type IconType = "lucide" | "iconsax";
export const SaxIconType: IconType = "iconsax";
export const LucideIconType: IconType = "lucide";

export interface CompozzIcon {
    name: string;
    type: IconType;
}